import { PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";
import { productsClient } from "@core/clients";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { Product, ProductResults, ProductsQueryParams } from "@core/types";

const useGetOnSaleProductsQuery = (props: ProductsQueryParams, options: UseQueryOptions<ProductResults> = {}) => {
  return useQuery<ProductResults, any>(
    ["products", "on-sale", props],
    async () => {
      return await productsClient.getOnSaleProducts(props);
    },
    {
      cacheTime: PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS,
      ...options,
    }
  );
};

export default useGetOnSaleProductsQuery;
